import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncBanner({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/bannerPage"));
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncBanner;
